// import FallPage from '@/pages/MpViews/FallPage.vue';
// import MileUserAuth from '@/pages/Protocol/MileUserAuth.vue';
// import NotFound from '@/components/NotFound.vue';

let base = [
  {
    path: '/NotFound',
    // component: FallPage,
    component: () => import(/* webpackChunkName: "not-found" */ '@/components/NotFound.vue'),
  },
  {
    path: '*',
    // component: NotFound,
    component: () => import(/* webpackChunkName: "not-found" */ '@/components/NotFound.vue'),
    hide: true,
  },
];

export default base;
